import { html, PropertyValues, TemplateResult } from 'lit';
import {
  API_TYPE_NIRVANA, WEB_COMPONENT_EXECUTIVE_SUMMARY_ACCESS_DATA_PROTECTION,
} from '../../../../webcomponents.constants';
import { GzGenericWidgetContent } from '../../../../genericDashboard/gzGenericWidget';
import { customElement, property, query } from 'lit/decorators.js';
import { GetWidgetDataRequest } from '../../../../types/widget/types';
import { Observable, of } from 'rxjs';
import {
  AccessDataProtectionPayload,
  GetAccessDataProtectionResponse,
} from '@nirvana/shared/dtos/types/widgets/common';
import { translateFn } from '../../../../utils/translator.helper';
import { getTimezone } from '../../../../utils/global.utils';
import { AccessDataProtectionComponent } from '../../../../accessDataProtection';
import { getDisplayMode, sanitizeReportingPeriod } from '../../../utils/utils';

@customElement(WEB_COMPONENT_EXECUTIVE_SUMMARY_ACCESS_DATA_PROTECTION)
export class GzAccessDataProtectionWebComponent extends GzGenericWidgetContent {
  @property({ type: Object, attribute: true, reflect: true })
  payload: AccessDataProtectionPayload;

  @query('#gzAccessDataProtection')
  private accessDataProtection: AccessDataProtectionComponent;

  injectDependencies(dependencies: any) {
    this.dependencies = dependencies;
  }

  getPayload() {
    return this.payload;
  }

  updated(_changedProperties: PropertyValues): void {
    super.updated(_changedProperties);

    const dependencies = {
      Ext: this.dependencies ? this.dependencies.Ext : undefined,
      getTimezone: getTimezone,
      getUserLanguage: Application.Main.getLanguage,
      translateFn: translateFn,
      api: {
        type: API_TYPE_NIRVANA,
        clients: {
          Widgets: {
            getAccessDataProtection: function (request: GetWidgetDataRequest): Observable<GetAccessDataProtectionResponse> {
              return of(this.getPayload().accessDataProtection);
            }.bind(this)
          }
        }
      }
    };

    if (this.accessDataProtection) {
      if (!this.accessDataProtection.started) {
        this.accessDataProtection.injectDependencies(dependencies);
        this.accessDataProtection.start();
      } else {
        this.accessDataProtection.controller?.render();
      }
    }
  }

  protected renderContent(): TemplateResult {
    return html `
      <gz-access-data-protection id="gzAccessDataProtection"
                                 data-reporting-period=${JSON.stringify(sanitizeReportingPeriod(this.payload?.reportingPeriod))}
                                 data-targets=${JSON.stringify(this.payload?.targets)}
                                 data-can-drill-down=${true}
                                 data-display-mode=${getDisplayMode()}
      ></gz-access-data-protection>`;
  }
}
